import { atom } from 'recoil';

// 送付先住所の詳細情報の型定義
export type SendBackAddressInfo = {
  deli_zip_code: string;
  deli_prefecture: string;
  deli_city: string;
  deli_town: string;
  deli_optional: string;
  deli_tel: string;
};

// 送付先住所の初期値
export const rentalWifiSendBackInfoState = atom<SendBackAddressInfo>({
  key: 'rentalWifiSendBackInfoState',
  default: {
    deli_zip_code: '',
    deli_prefecture: '',
    deli_city: '',
    deli_town: '',
    deli_optional: '',
    deli_tel: '',
  },
});

export default rentalWifiSendBackInfoState;
